import React, { useEffect, useLayoutEffect, useState } from "react";
import Location from "../Location/Location";
import ToolBar from "../Toolbar/Toolbar";
import CropSingleImage from "../CropSingleImage/CropSingleImage";
import CropMultipleImage from "../CropMultipleImage/CropMultipleImage";
import PriceInput from "../PriceInput/PriceInput";
import DynamicPermissionPage from "../../pages/DynamicPermissionPage/DynamicPermissionPage";
import TimePicker from "../TimePicker/TimePicker";
import HasMany from "../HasMany/HasMany";
import FileInput from "../FileInput/FileInput";
import SelectRoute from "../SelectRoute/SelectRoute";
import SelectSearch from "../SelectSearch/SelectSearch";
import SelectMultiple from "../SelectMultiple/SelectMultiple";
import SelectDynamicNew from "../SelectDynamicNew/SelectDynamicNew";
import Switch from "../Switch/Switch";
import DatePickerCustomize from "../DatePickerCustomize/DatePickerCustomize";
import TextArea from "../TextArea/TextArea";
import Information from "../Information/Information";
import SelectRouteMultiple from "../SelectRouteMultiple/SelectRouteMultiple";
import ShowImage from "../ShowImage/ShowImage";
import InputLabel from "../InputLabel/InputLabel";
import DatePickerYearCustomize from "../DatePickerYearCustomize/DatePickerYearCustomize";
import Services from "../Services/Services";
import VideoInput from "../VideoInput/VideoInput";
import axios from "axios";
import ShowExpertDetail from "../ShowExpertDetail/ShowExpertDetail";
import ReportPdf from "../ReportPdf/ReportPdf";
import ShowAttributeExpertDetail from "../ShowAttributeExpertDetail/ShowAttributeExpertDetail";
import ShowAttributeExpertRequestDetail from "../ShowAttributeExpertRequestDetail/ShowAttributeExpertRequestDetail";
import SelectAllSelectSearchMultiple from "../SelectAllSelectSearchMultiple/SelectAllSelectSearchMultiple";
import { useLocation } from "react-router-dom";

function useForceUpdate() {
  const [value, setState] = useState(true);
  return () => setState(!value);
}

const EditInputComponent = (props) => {
  const [textValue, setTextValue] = useState(props.editDataValue);
  const handleForceupdateMethod = useForceUpdate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get("loc");

  // function DatePickerInput(props) {
  //   return <input className="outline-none" {...props} />;
  // }

  const [localInputData, setLocalInputData] = useState(props.inputData || {});

  function textInputChanger(event, inputType) {
    if ("HasManyInputData" in props) {
      props.HasManyInputData(props.index, props.HasManyKey, event.target.value);
      setTextValue(event.target.value);
    }
    if (inputType === "number") {
      setTextValue(+event.target.value);
    } else {
      setTextValue(event.target.value);
    }
  }

  useEffect(() => {
    console.log("props.inputData changed:", props.inputData);
    if (paramValue === "url") {
      setLocalInputData({ ...props.inputData });
    }
  }, [props.inputData]);

  useEffect(() => {
    console.log("localInputData changed:", localInputData);
    if (paramValue === "url") {
      props.setInputData({ ...localInputData });
    }
  }, [localInputData, props.setInputData]);

  useEffect(() => {
    console.log(props.inputData,localInputData,'sjuueeu')
  }, [props.inputData,localInputData]);

  useEffect(() => {
    setTextValue(props.editDataValue);
  }, [props.editDataValue]);

  function textFilder(event, inputType) {
    if ("HasManyInputData" in props) {
      props.HasManyInputData(props.index, props.HasManyKey, event.target.value);
    } else {
      let object = props.inputData;
      if (inputType === "number") {
      }
      object[props.item.key] =
        inputType === "number" ? +event.target.value : event.target.value;
      props.setInputData(object);
    }
  }

  useLayoutEffect(() => {
    props.setInputData(props.inputData);
    let selectSearchOptions = [];
    let obj = props.selectSearchData;
    let selectDynamicObj = props.selectDynamicData;
    if (props.item.controlType === "select_dynamic") {
      selectDynamicObj[props.item.key + "-" + "0"] = props.item.options;
      selectDynamicObj["label"] = null;
      props.setSelectDynamicData(selectDynamicObj);
    }
    if (props.item.controlType === "select_search" && props.item.relation) {
      if (props.pageType === "edit") {
        axios
          .get(`${props.item.route}${props.editDataValue}`)
          .then((res) => {
            if (res?.status === 200) {
              // setOption(props.selectSearchData[props.item.key]);
              // for (let option of res?.data?.data) {
              //   selectSearchOptions.push({
              //     label: option.label,
              //     value: option.value,
              //   });
              // }
              // console.log(obj, "askdfjkekekeuu");

              obj[props.item.relation] = res?.data?.data;
              props.setSelectSearchData({ ...obj });
            }
          })
          .then(() => {
            // props.handleForceupdateMethod();
          })
          .catch((error) => {
            console.log(error);
          });
      }

      for (let option of props.item.options) {
        selectSearchOptions.push({ label: option.label, value: option.value });
      }
      obj[props.item.key] = selectSearchOptions;
      props.setSelectSearchData(obj);
    } else if (props.item.controlType === "select_search") {
      if (!Array.isArray(props.item.options)) {
        selectSearchOptions.push({ label: "", value: "" });
      } else {
        for (let option of props.item.options) {
          selectSearchOptions.push({
            label: option.label,
            value: option.value,
          });
        }
      }
      obj[props.item.key] = selectSearchOptions;
      props.setSelectSearchData(obj);
    }
    setColStyle();

    if (props.item.required === true && props.required && !props.HasManyData) {
      let array = props.required;
      let object = {};
      object.key = props.item.key;
      object.label = props.item.label;
      array.push(object);
      props.setRequired(array);
    }
    // if(props.HasManyData && props.item.required === true){
    //     console.log(props)
    //     // let array = props.required;
    //     let object = {};
    //         object.key = props.item.key;
    //         object.label = props.item.label;
    //         array.push(object);
    //     props.setRequired(array);
    //     console.log(array)
    // }
  }, []);

  useEffect(() => {
    if (!(props.item.value === "")) {
      setTextValue(props.item.value);
      let object = props.inputData;
      object[props.item.key] = props.item.value;
      props.setInputData(object);
    }
  }, [props.inputData]);

  function setColStyle() {
    if (document.getElementById(props.id)) {
      props.item.col
        ? document
            .getElementById(props.id)
            .classList.add(`col-${props.item.col}`)
        : document.getElementById(props.id).classList.add(`col-${12}`);
    }
  }

  switch (props.item.controlType) {
    case "text":
      return (
        <div
          className={`flex flex-col gap-y-[8px] `}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className={`flex flex-col`}>
            <input
              className={`h-[38px] ${
                props.item.disabled !== undefined || props.item.disabled
                  ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#b5b5b5] text-edit_input_text_disabled"
                  : "bg-white dark:bg-[#ffffffdd] text-edit_input_text"
              }  border border-edit_input_border dark:text-[#555555] rounded-[4px] px-3 w-full`}
              disabled={props.item.disabled}
              onChange={(event) => textInputChanger(event, props.item.type)}
              onBlur={(event) => textFilder(event, props.item.type)}
              value={textValue}
              index={props.index}
              type={props.item.type || "text"}
              placeholder={props.item.placeholder}
            />
            <div className="mt-2 text-[.8rem] text-edit_input_validation">
              {props.children}
            </div>
          </div>
        </div>
      );
    case "select":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className="col-span-full sm:col-auto">
            <select
              className={`h-[38px] border dark:bg-[#ffffffdd] border-edit_input_border dark:text-[#555555] 
              ${
                props.item.disabled !== undefined || props.item.disabled
                  ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#b5b5b5] text-edit_input_text_disabled"
                  : "bg-white dark:bg-[#ffffffdd] text-edit_input_text"
              }
              rounded-[4px] px-2 w-full `}
              onChange={textInputChanger}
              value={textValue}
              onBlur={textFilder}
              index={props.index}
              disabled={props.item.disabled}
            >
              <option value={""}>انتخاب کنید</option>
              {props.item.options !== undefined
                ? props.item.options.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))
                : ""}
            </select>
            <div className="mt-2 text-[.8rem] text-edit_input_validation">
              {props.children}
            </div>
          </div>
        </div>
      );
    case "select_multiple":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <SelectMultiple
            item={props.item}
            inputData={props.inputData}
            setInputData={props.setInputData}
            editDataValue={props.editDataValue}
            pageType={props.pageType}
          />
        </div>
      );
    case "select_route":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className="col-span-full sm:col-auto">
            <SelectRoute
              itemRoute={props.item.route}
              HasManyKey={props.HasManyKey}
              item={props.item}
              inputData={props.inputData}
              setInputData={props.setInputData}
              HasManyInputData={props.HasManyInputData}
              index={props.index}
              machOptionsClass={"matche-options" + props.index}
              editDataValue={props.editDataValue}
              pageType={props.pageType}
              children={props.children}
            />
          </div>
        </div>
      );
    case "select_route_multiple":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className="col-span-full sm:col-auto">
            <SelectRouteMultiple
              itemRoute={props.item.route}
              HasManyKey={props.HasManyKey}
              item={props.item}
              inputData={props.inputData}
              setInputData={props.setInputData}
              HasManyInputData={props.HasManyInputData}
              index={props.index}
              machOptionsClass={"matche-options" + props.index}
              editDataValue={props.editDataValue}
              pageType={props.pageType}
              children={props.children}
            />
          </div>
        </div>
      );
    case "select_all_select_search_multiple":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className="col-span-full sm:col-auto">
            <SelectAllSelectSearchMultiple
              item={props.item}
              inputData={props.pageType==='create' ? props.inputData : localInputData}
              setInputData={props.pageType === 'create' ? props.setInputData : setLocalInputData}
            />
          </div>
        </div>
      );
    case "select_search":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <SelectSearch
            index={props.index}
            item={props.item}
            inputData={props.inputData}
            setInputData={props.setInputData}
            pageType={props.pageType}
            editDataValue={props.editDataValue}
            selectSearchData={props.selectSearchData}
            setSelectSearchData={props.setSelectSearchData}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            handleForceupdateMethod={handleForceupdateMethod}
            matchpointId={props.matchpointId}
            children={props.children}
            id={props.id}
          />
        </div>
      );
    case "select_dynamic":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <SelectDynamicNew
            inputData={props.inputData}
            setInputData={props.setInputData}
            pageType={props.pageType}
            label={props.item.label}
            keyItem={props.item.key}
            route={props.item.route}
            index={props.index}
            HasManyInputData={props.HasManyInputData}
            HasManyKey={props.HasManyKey}
            editData={props.editData}
            selectDynamicData={props.selectDynamicData}
            options={props.item.options}
            children={props.children}
            item={props.item}
            editDataValue={props.editDataValue}
          />
        </div>
      );
    case "switch":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className="col-span-full sm:col-auto">
            <Switch
              index={props.index}
              options={props.item.options}
              inputData={props.inputData}
              setInputData={props.setInputData}
              HasManyKey={props.HasManyKey}
              HasManyInputData={props.HasManyInputData}
              item={props.item}
              pageType={props.pageType}
              editDataValue={props.editDataValue}
            />
            <div className="mt-2 text-[.8rem] text-edit_input_validation">
              {props.children}
            </div>
          </div>
        </div>
      );
    case "textarea":
      return (
        <div className={`flex flex-col gap-y-[8px]`} id={props.id}>
          <InputLabel item={props.item} />
          <TextArea
            children={props.children}
            disabled={props.item.disabled}
            onchange={textInputChanger}
            onblur={textFilder}
            value={textValue}
          />
        </div>
      );
    case "date":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div
            className={`datePicker h-[38px] border border-edit_input_border text-edit_input_text rounded-[4px]`}
          >
            <DatePickerCustomize
              pageType={props.pageType}
              keyValue={props.item.key}
              inputData={props.inputData}
              setInputData={props.setInputData}
              editDataValue={
                props.editDataValue || props.editDataValue === 0
                  ? props.editDataValue
                  : []
              }
              keyItem={props.item.key}
              item={props.item}
              index={props.index}
              HasManyKey={props.HasManyKey}
              HasManyInputData={props.HasManyInputData}
            />
          </div>
          <div className="mt-2 text-[.8rem] text-edit_input_validation">
            {props.children}
          </div>
        </div>
      );
    case "date_year":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div
            className={`datePicker h-[38px] border border-edit_input_border text-edit_input_text rounded-[4px]`}
          >
            <DatePickerYearCustomize
              pageType={props.pageType}
              keyValue={props.item.key}
              inputData={props.inputData}
              setInputData={props.setInputData}
              editDataValue={
                props.editDataValue || props.editDataValue === 0
                  ? props.editDataValue
                  : []
              }
              keyItem={props.item.key}
              item={props.item}
              index={props.index}
              HasManyKey={props.HasManyKey}
              HasManyInputData={props.HasManyInputData}
            />
          </div>
          <div className="mt-2 text-[.8rem] text-edit_input_validation">
            {props.children}
          </div>
        </div>
      );
    case "single_image":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <CropSingleImage
            imageType={props.item.type}
            inputData={props.inputData}
            setInputData={props.setInputData}
            keyValue={props.item.key}
            pageType={props.pageType}
            index={props.index}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            editDataValue={props.editDataValue}
            item={props.item}
            error={props.children}
          />
        </div>
      );
    case "multiple_image":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <CropMultipleImage
            imageType={props.item.type}
            inputData={props.inputData}
            setInputData={props.setInputData}
            keyValue={props.item.key}
            index={props.index}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            editDataValue={props.editDataValue}
            item={props.item}
            error={props.children}
            pageType={props.pageType}
          />
        </div>
      );
    case "map":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div>
            <Location
              inputData={props.inputData}
              setInputData={props.setInputData}
              item={props.item}
              index={props.index}
              HasManyKey={props.HasManyKey}
              HasManyInputData={props.HasManyInputData}
              editDataValue={props.editDataValue}
            />
            <div className="mt-2 text-[.8rem] text-edit_input_validation">
              {props.children}
            </div>
          </div>
        </div>
      );
    case "tiny":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <div className="col-span-full sm:col-auto">
            <ToolBar
              inputData={props.inputData}
              setInputData={props.setInputData}
              item={props.item}
              index={props.index}
              HasManyKey={props.HasManyKey}
              HasManyInputData={props.HasManyInputData}
              editDataValue={props.editDataValue}
            />
            <div className="mt-2 text-[.8rem] text-edit_input_validation">
              {props.children}
            </div>
          </div>
        </div>
      );
    case "price":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <PriceInput
            item={props.item}
            inputData={props.inputData}
            setInputData={props.setInputData}
            key={props.item.key}
            keyValue={props.item.key}
            data={props.item}
            index={props.index}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            editDataValue={props.editDataValue}
            error={props.children}
          />
        </div>
      );
    case "permission":
      return (
        <div
          className="col-span-full overflow-x-scroll 1480:overflow-x-hidden "
          key={props.id}
        >
          <DynamicPermissionPage
            item={props.item}
            setIsEnable={props.setIsEnable}
            isEnable={props.isEnable}
            inputData={props.inputData}
            setInputData={props.setInputData}
          />
        </div>
      );
    case "time":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <TimePicker
            maxTime={props.item.maxTime}
            minTime={props.item.minTime}
            ampm={props.item.ampm}
            inputData={props.inputData}
            setInputData={props.setInputData}
            editDataValue={props.editDataValue}
            keyValue={props.item.key}
            index={props.index}
            HasManyKey={props.HasManyKey}
            pageType={props.pageType}
            HasManyInputData={props.HasManyInputData}
            item={props.item}
          />
        </div>
      );
    case "has_many":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          {props.item.attributes && <InputLabel item={props.item} />}
          {props.item.attributes && (
            <HasMany
              item={props.item}
              label={props.item.label}
              inputData={props.inputData}
              setInputData={props.setInputData}
              keyValue={props.item.key}
              pageType={props.pageType}
              data={
                props.item.attributes !== undefined ? props.item.attributes : []
              }
              editDataValue={props.editDataValue}
              id={props.id}
              setColStyle={setColStyle}
            />
          )}
        </div>
      );
    case "file":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <FileInput
            item={props.item}
            label={props.item.label}
            disabled={props.item.disabled}
            accept={props.item.patern}
            multiple={props.item.multiple}
            type={props.item.type}
            inputData={props.inputData}
            setInputData={props.setInputData}
            keyValue={props.item.key}
            pageType={props.pageType}
            index={props.index}
            editDataValue={props.editDataValue}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            id={props.id}
          />
        </div>
      );
    case "video":
      return (
        <VideoInput
          item={props.item}
          label={props.item.label}
          disabled={props.item.disabled}
          accept={props.item.patern}
          multiple={props.item.multiple}
          type={props.item.type}
          inputData={props.inputData}
          setInputData={props.setInputData}
          keyValue={props.item.key}
          pageType={props.pageType}
          index={props.index}
          editDataValue={props.editDataValue}
          HasManyKey={props.HasManyKey}
          HasManyInputData={props.HasManyInputData}
          id={props.id}
        />
      );
    case "information":
      return (
        <Information
          item={props.item}
          label={props.item.label}
          editDataValue={props.editDataValue}
          inputData={props.inputData}
          setInputData={props.setInputData}
        />
      );
    case "show_image":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <ShowImage
            imageType={props.item.type}
            inputData={props.inputData}
            setInputData={props.setInputData}
            keyValue={props.item.key}
            index={props.index}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            editDataValue={props.editDataValue}
            item={props.item}
            error={props.children}
            pageType={props.pageType}
          />
        </div>
      );
    case "services":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <Services
            imageType={props.item.type}
            inputData={props.inputData}
            setInputData={props.setInputData}
            keyValue={props.item.key}
            index={props.index}
            HasManyKey={props.HasManyKey}
            HasManyInputData={props.HasManyInputData}
            editDataValue={props.editDataValue}
            item={props.item}
            error={props.children}
            pageType={props.pageType}
          />
        </div>
      );
    case "show_expert_detail":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <ShowExpertDetail data={props.item} />
        </div>
      );
    case "show_attribute_expert_detail":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <ShowAttributeExpertDetail data={props.item} />
        </div>
      );
    case "show_attribute_expert_request_detail":
      return (
        <div
          className={`flex flex-col gap-y-[8px]`}
          id={props.id}
          key={props.id}
        >
          <ShowAttributeExpertRequestDetail data={props.item} />
        </div>
      );

    case "report_pdf":
      return (
        <div
          className={`flex flex-col gap-y-[8px] overflow-hidden`}
          id={props.id}
          key={props.id}
        >
          <InputLabel item={props.item} />
          <ReportPdf data={props} />
        </div>
      );
    default:
      return "";
  }
};
export default EditInputComponent;
